module.exports = __webpack_public_path__ + "img/ring_y_s_null_null@3x.4d34ccbc.png";